import React from "react";
import { Button } from "devextreme-react/button";
import { ResourceIdCopyIconSVG } from "../../Assets/SVGs/ResourceSVGs";
import Notification from "../Notification/Notification";
import { ApiSuccessMsgs } from "../../Constants/constants";
import "./ResourceVersionTooltip.scss";

// while this component looks like a standard component (returning jsx), it's actually called like a function
// this is because it's passed into the contentRender of a popover from DX
const ResourceVersionTooltip = (organizationName, id, details) => {
  const { description, purpose } = details;
  const copyResourceId = () => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        Notification(ApiSuccessMsgs.ResourceIdCopied, "success");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="resource-popover-div">
      <span className="popover-headers">Author:</span>
      <span className="popover-data">{organizationName}</span>
      <span className="popover-headers">Resource version ID:</span>
      <span className="popover-data">
        {id}
        <Button onClick={copyResourceId} stylingMode="text">
          {ResourceIdCopyIconSVG}
        </Button>
      </span>
      <span className="popover-headers">Purpose:</span>
      <span className="popover-data">{purpose}</span>
      <span className="popover-headers">Resource description:</span>
      <span className="popover-data">{description}</span>
    </div>
  );
};
export default ResourceVersionTooltip;
